import type { PaymentType } from '#src/app/shared/utils/payments';

import type { PromoteFormViewerFieldsFragment } from '../../shared/api/promoteFormViewerFields.graphql';
import type { SavedPaymentMethod } from '../context';

export function normalizeSavedPaymentMethods(
	paymentMethods: NonNullable<PromoteFormViewerFieldsFragment['userProtectedData']>['paymentMethods'] | undefined,
): SavedPaymentMethod[] {
	if (!paymentMethods) return [];
	return (
		paymentMethods
			// Remove any saved payment methods that can't be used
			.filter(
				(paymentMethod) => paymentMethod.settings.supportsOneTimeCharges, // This field being set is another condition that makes it valid for use.
			)
			// Add a type field to each one for use throughout the UI logic, for tracking events, etc
			.map((paymentMethod) => {
				return {
					...paymentMethod,
					type: {
						PaymentMethodCreditCard: 'creditCard',
						PaymentMethodPayPal: 'paypal',
						PaymentMethodSepa: 'sepa',
						PaymentMethodVenmo: 'venmo',
						PaymentMethodLink: 'link',
					}[paymentMethod.__typename] as PaymentType,
				};
			})
	);
}
